import Box from '@mui/material/Box';
import NRRiseAiIcon from '../../../NRIcons/NRRiseAiIcon';
import NRAIMorphSpinner from '../../NRAIMorphSpinner/NRAIMorphSpinner';

const ICON_SIZE = 20;

function NRRiseAiMorphIcon({ complete, showStatic, onComplete, color }) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: ICON_SIZE,
        height: ICON_SIZE,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          lineHeight: 0,
          opacity: showStatic ? 0 : 1,
          transition: 'opacity 200ms ease-in-out',
          pointerEvents: 'none'
        }}
      >
        <NRAIMorphSpinner
          size={ICON_SIZE}
          color={color}
          complete={complete}
          onComplete={onComplete}
          sx={{ display: 'flex' }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: showStatic ? 1 : 0,
          transition: 'opacity 200ms ease-in-out'
        }}
      >
        <NRRiseAiIcon height={String(ICON_SIZE)} width={String(ICON_SIZE)} color={color} />
      </Box>
    </Box>
  );
}

export default NRRiseAiMorphIcon;
